import api from './api';
import { ContractStatus, BookingStatus, WelcomeEmailStatus, AdobeStatus } from '@/types';

export interface DashboardStats {
  totalUnits: number;
  contractStatusCounts: {
    total: number;
  } & Record<ContractStatus, number>;
  bookingStatusCounts: {
    total: number;
  } & Record<BookingStatus, number>;
  welcomeEmailStatusCounts: {
    total: number;
  } & Record<WelcomeEmailStatus, number>;
  adobeStatusCounts: {
    total: number;
    none: number; // Special case for contracts without Adobe status
  } & Record<AdobeStatus, number>;
}

export interface DashboardStatsResponse {
  success: boolean;
  data: DashboardStats;
  stats?: any; // Additional detailed stats for flexibility
}

/**
 * Fetch dashboard statistics from the server
 * @returns Promise containing aggregated dashboard statistics
 */
export const getDashboardStats = async (): Promise<DashboardStats> => {
  try {
    const response = await api.get<DashboardStatsResponse>('/api/clc/dashboard/stats');
    
    if (response.data.success) {
      return response.data.stats;
    } else {
      throw new Error('Failed to fetch dashboard stats');
    }
  } catch (error: any) {
    console.error('Error fetching dashboard stats:', error);
    throw new Error(error.message || 'Failed to fetch dashboard stats');
  }
};
